import { Input, Skeleton } from "antd";
import React, { useMemo, useState } from "react";
import Icon from "../../../../assets/Icon";
import FGIndustryCard from "./FGIndustryCard";

const FreeGuidesIndustrySide = ({
  industriesList,
  selectedIndustry,
  setSelectedIndustry,
  industryLoading,
}) => {
  const [industrySearchText, setIndustrySearchText] = useState("");

  const filteredIndustries = useMemo(() => {
    if (!industrySearchText.trim()) {
      return industriesList || [];
    }

    return (industriesList || []).filter((industry) =>
      industry.industryTitle
        .toLowerCase()
        .includes(industrySearchText.toLowerCase())
    );
  }, [industriesList, industrySearchText]);

  return (
    <div className="border-r border-gray-200 pr-[.65rem] shadow-sm">
      <div className="text-darkish text-[1rem] font-semibold">
        Industry type
      </div>
      <div className="text-lightGreyish font-medium text-sm">
        Select industry type
      </div>
      <div className="pr-1 mt-[.8rem]">
        <Input
          value={industrySearchText}
          onChange={(e) => setIndustrySearchText(e.target.value)}
          className="w-full  px-2 py-[0.36rem] border border-[#D0D5DD] shadow-sm"
          prefix={<Icon type="search-icon" />}
          placeholder="Search industry"
        />
      </div>
      <div className="flex flex-col gap-[.65rem] mt-4 overflow-y-auto orange-scroll max-h-[180px] md:max-h-none md:h-[450px] pr-1">
        {!industryLoading ? (
          filteredIndustries?.length > 0 ? (
            filteredIndustries?.map((industry, ind) => (
              <FGIndustryCard
                key={industry.industryId}
                selectedIndustry={selectedIndustry}
                setSelectedIndustry={setSelectedIndustry}
                industry={industry}
              />
            ))
          ) : (
            <div className="text-lightGreyish text-center mt-2 text-[.95rem] pb-5">
              {industrySearchText.trim()
                ? "No matching industries found."
                : "No industries found."}
            </div>
          )
        ) : (
          <div>
            <Skeleton.Button
              active
              block
              style={{ height: 60, marginBottom: 12 }}
            />
            <Skeleton.Button
              active
              block
              style={{ height: 60, marginBottom: 12 }}
            />
            <Skeleton.Button active block style={{ height: 60 }} />
          </div>
        )}
      </div>
    </div>
  );
};

export default FreeGuidesIndustrySide;
